import { get } from 'lodash';
import { ParsedCard, ParsedItem } from '../../../../../store/declaration-form-errors/ParsedForm';
import { parseFieldErrorsForCard, parseFieldErrorsForMultipleCard } from '../../../../../utils/validationParserUtils';

const irelandTsdValidationErrorsParser = (validation: any) => {
    const masterDetailsErrors: ParsedCard[] = [];

    parseFieldErrorsForCard(
        'Customs Offices',
        [
            { 'declaration.customsOffices.supervisingCustomsOffice527': 'Supervising Customs Office' },
            { 'declaration.customsOffices.customsOfficeLodgement': 'Customs Office of Lodgement' },
            { numberOfItems: 'Number of Items' },
        ],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForCard(
        'Parties',
        [
            { 'declaration.parties.declarant.declarant318': 'Identification Number' },
            { 'declaration.parties.representative.representative320': 'Identification Number' },
            { 'declaration.parties.representative.representativeStatus321': 'Representative status' },
        ],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Simplified Declaration / Previous Documents / Writing-off',
        'goodsShipment.documentsAuthorisations.simplifiedDeclarationDocumentWritingOff201',
        [
            { previousDocumentType: 'Previous Document Type' },
            { previousDocumentIdentifier: 'Previous Document Reference' },
            { previousDocumentLineId: 'Declaration Line Number Previously Recorded' },
        ],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Additional Information',
        'goodsShipment.documentsAuthorisations.additionalInformation22',
        [
            { additionalInformationCode: 'Additional Statement Code' },
            { additionalInformationText: 'Additional Statement Text' },
        ],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Documents Produced / Certificates and Authorisations / Additional References',
        'goodsShipment.documentsAuthorisations.producedDocumentsWritingOff203',
        [{ documentType: 'Type' }, { documentIdentifier: 'Id' }],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForCard(
        'Reference Number',
        [{ 'goodsShipment.documentsAuthorisations.ucr24': 'UCR' }],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForCard(
        'Identification of Warehouse',
        [
            { 'goodsShipment.documentsAuthorisations.warehouseIdentification27.warehouseType': 'Warehouse Type' },
            {
                'goodsShipment.documentsAuthorisations.warehouseIdentification27.warehouseIdentifier':
                    'Warehouse Identifier',
            },
        ],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForCard(
        'Location of Goods',
        [
            { 'goodsShipment.datesPlaces.locationGoods523.identificationOfLocation': 'Identification of Location' },
            {
                'goodsShipment.datesPlaces.locationGoods523.qualifierIdentification': 'Qualifier of the Identification',
            },
            { 'goodsShipment.datesPlaces.locationGoods523.additionalIdentifier': 'Additional Identifier' },
            { 'goodsShipment.datesPlaces.locationGoods523.locationTypeCode': 'Type of Location Code' },
            {
                'goodsShipment.datesPlaces.locationGoods523.address.city': 'Address - City',
            },
            {
                'goodsShipment.datesPlaces.locationGoods523.address.countryCode': 'Address - Country',
            },
            { 'goodsShipment.datesPlaces.locationGoods523.address.streetAndNumber': 'Address - Street and Number' },
            { 'goodsShipment.datesPlaces.locationGoods523.address.postcode': 'Address - Postcode' },
        ],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForCard(
        'Transportation',
        [
            {
                'goodsShipment.transportInformation.arrivalTransportMeansId79.identificationType':
                    'Type of Identification',
            },
            {
                'goodsShipment.transportInformation.arrivalTransportMeansId79.identificationNumber':
                    'Identification Number',
            },
            {
                'goodsShipment.transportInformation.containerIdentificationNumber710.0.containerIdentificationNumber':
                    'Container Identification Number 1',
            },
            {
                'goodsShipment.transportInformation.containerIdentificationNumber710.1.containerIdentificationNumber':
                    'Container Identification Number 2',
            },
            {
                'goodsShipment.transportInformation.containerIdentificationNumber710.2.containerIdentificationNumber':
                    'Container Identification Number 3',
            },
            {
                'goodsShipment.transportInformation.containerIdentificationNumber710.3.containerIdentificationNumber':
                    'Container Identification Number 4',
            },
            {
                'goodsShipment.transportInformation.containerIdentificationNumber710.4.containerIdentificationNumber':
                    'Container Identification Number 5',
            },
            { 'goodsShipment.transportInformation.seal.sealNumber718': 'Number of Seals' },
            {
                'goodsShipment.transportInformation.seal.sealIdentifier718.0.sealIdentifier': 'Seal Identifier 1',
            },
            {
                'goodsShipment.transportInformation.seal.sealIdentifier718.1.sealIdentifier': 'Seal Identifier 2',
            },
            {
                'goodsShipment.transportInformation.seal.sealIdentifier718.2.sealIdentifier': 'Seal Identifier 3',
            },
            {
                'goodsShipment.transportInformation.seal.sealIdentifier718.3.sealIdentifier': 'Seal Identifier 4',
            },
            {
                'goodsShipment.transportInformation.seal.sealIdentifier718.4.sealIdentifier': 'Seal Identifier 5',
            },
        ],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForCard(
        'Total Gross Weight',
        [{ 'goodsShipment.grossMass65': 'Total Gross Weight' }],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Supply Chain Actor',
        'goodsShipment.supplyChainActor337',
        [{ roleCode: 'Role Code' }, { traderIdentification: 'Identifier' }],
        masterDetailsErrors,
        validation
    );

    parseFieldErrorsForCard(
        'Presentation',
        [
            {
                'goodsShipment.presentation.presentationTrader330':
                    'Person Presenting the Goods to Customs Identification No.',
            },
            { 'goodsShipment.presentation.firstEntryCustomsOffice524': 'Customs Office of First Entry' },
            {
                'goodsShipment.presentation.activeBorderTransportMeansId714.identificationType':
                    'Type of Identification',
            },
            {
                'goodsShipment.presentation.activeBorderTransportMeansId714.identificationNumber':
                    'Identification Number',
            },
        ],
        masterDetailsErrors,
        validation
    );

    const itemsErrors: ParsedItem[] = [];
    parseDeclarationItems(itemsErrors, validation);

    return {
        masterDetails: masterDetailsErrors,
        items: itemsErrors,
    };
};

const parseDeclarationItems = (errors: ParsedItem[], validation: any) => {
    const products = get(validation, 'goodsShipment.goodsShipmentItem');

    if (!Array.isArray(products)) return;

    products?.forEach((itemErrors: any, index: number) => {
        const item = { index: index + 1, errors: [] };

        parseDeclarationItem(item.errors, itemErrors);

        if (item.errors.length > 0) {
            errors.push(item);
        }
    });
};

const parseDeclarationItem = (parsed: ParsedCard[], validation: any) => {
    parseFieldErrorsForCard(
        'Goods Information',
        [
            {
                'goodsInformation.cusCode613': 'CUS Code',
            },
            {
                'goodsInformation.commodityCode.combinedNomenclatureCode614':
                    'Commodity Code - Combined Nomenclature Code',
            },
            { 'goodsInformation.goodsDescription68': 'Description of Goods' },
            { 'goodsInformation.grossMass65': 'Gross Mass' },
        ],
        parsed,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Simplified Declaration / Previous Documents / Writing-off',
        'documentsAuthorisations.simplifiedDeclarationDocumentWritingOff201',
        [
            { previousDocumentType: 'Previous Document Type' },
            { previousDocumentIdentifier: 'Previous Document Reference' },
            { previousDocumentLineId: 'Declaration Line Number Previously Recorded' },
        ],
        parsed,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Additional Information',
        'documentsAuthorisations.additionalInformation22',
        [
            { additionalInformationCode: 'Additional Statement Code' },
            { additionalInformationText: 'Additional Statement Text' },
        ],
        parsed,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Documents Produced / Certificates and Authorisations / Additional References',
        'documentsAuthorisations.producedDocumentsWritingOff203',
        [{ documentType: 'documentType' }, { documentIdentifier: 'documentIdentifier' }],
        parsed,
        validation
    );

    parseFieldErrorsForCard('Reference Number', [{ 'documentsAuthorisations.ucr24': 'UCR' }], parsed, validation);

    parseFieldErrorsForMultipleCard(
        'Supply Chain Actor',
        'supplyChainActor337',
        [{ roleCode: 'Role Code' }, { traderIdentification: 'Identifier' }],
        parsed,
        validation
    );

    parseFieldErrorsForMultipleCard(
        'Packaging',
        'goodsInformation.packaging',
        [
            { typePackage69: 'Type of Packages' },
            { packageNumber610: 'Number of Packages' },
            { shippingMarks611: 'Shipping Marks' },
        ],
        parsed,
        validation
    );

    parseFieldErrorsForCard(
        'Transportation',
        [
            {
                'transportInformation.containerIdentificationNumber710.0.containerIdentificationNumber':
                    'Container Identification Number 1',
            },
            {
                'transportInformation.containerIdentificationNumber710.1.containerIdentificationNumber':
                    'Container Identification Number 2',
            },
            {
                'transportInformation.containerIdentificationNumber710.2.containerIdentificationNumber':
                    'Container Identification Number 3',
            },
            {
                'transportInformation.containerIdentificationNumber710.3.containerIdentificationNumber':
                    'Container Identification Number 4',
            },
            {
                'transportInformation.containerIdentificationNumber710.4.containerIdentificationNumber':
                    'Container Identification Number 5',
            },
        ],
        parsed,
        validation
    );
};

export default irelandTsdValidationErrorsParser;
